import {
  Component,
  Input,
  ChangeDetectionStrategy,
  AfterViewInit,
  ChangeDetectorRef,
  SimpleChanges,
  OnChanges
} from '@angular/core';
import { Product } from '@vestiaire/api-sdk-angular';
import { IAppState } from '@app/store';
import { Store, select } from '@ngrx/store';
import * as fromUser from '@app/core/user/store/reducers';
import { ClickConsigmentCTA } from '@app/+product/store';
import { UserBadge } from '@vestiaire/api-sdk-angular';
import { pathToLocales } from '@app/landings/seller-rating-page/seller-rating-page.component';
import { LocaleService } from '@app/core/i18n';

@Component({
  selector: 'vc-product-seller-block',
  templateUrl: './product-seller-block.component.html',
  styleUrls: ['./product-seller-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductSellerBlockComponent implements AfterViewInit, OnChanges {
  @Input()
  product: Product;
  @Input()
  sellerPro: boolean;
  isFollow: boolean;
  expertSellerBadge = false;
  trustedSellerBadge = false;
  fashionActivistBadge = false;
  officialStoreBadge = false;
  public path = '/seller-badges/';

  constructor(
    private store: Store<IAppState>,
    private localeService: LocaleService,
    private detectorRef: ChangeDetectorRef
  ) {
    this.path = pathToLocales[this.localeService.getLanguageTag()];
  }

  ngAfterViewInit() {
    this.store.pipe(select(fromUser.getFollowingMembers)).subscribe(
      res => {
        if (res && Array.isArray(res)) {
          this.isFollow = res.indexOf(this.product.seller.id) !== -1;
          this.detectorRef.detectChanges();
        }
      },
      err => {}
    );
  }

  hasProductSold(): boolean {
    return this.product.seller.statistics.productsSold > 0;
  }

  trackConsignmentClick(e) {
    this.store.dispatch(new ClickConsigmentCTA('user_details'));
    e.stopPropagation();
  }

  setBadges(userBadges: UserBadge[]): void {
    if (!userBadges) {
      return;
    }
    userBadges.forEach((badge: UserBadge) => {
      switch (badge) {
        case UserBadge.ExpertSeller:
          this.expertSellerBadge = true;
          break;
        case UserBadge.TrustedSeller:
          this.trustedSellerBadge = true;
          break;
        case UserBadge.FashionActivist:
          this.fashionActivistBadge = true;
          break;
        case UserBadge.OfficialStore:
          this.officialStoreBadge = true;
          break;
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.setBadges(this.product.seller.badges);
  }
}
